import axios from "axios";
import { apiURL } from './api.js';

// Function to get user's subscription(s)
export const getUserSubscription = async (userId) => {
    try {

        const token = localStorage.getItem('authToken');
        
        if (!userId) {
            throw new Error('User ID is required');
        }

        if (!token) {
            throw new Error('Authentication token is required');
        }
        
        const response = await axios.get(`${apiURL}/subscriptions/user/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (response.status !== 200) {
            throw new Error('Failed to fetch subscription');
        }
        
        const data = response.data;
        // API returns { status: true, subscriptions: [...] }
        const subscriptions = data.subscriptions || data;
        // Return the most recent subscription
        return Array.isArray(subscriptions) && subscriptions.length > 0 ? subscriptions[0] : null;
    } catch (error) {
        console.error('Error fetching user subscription:', error);
        throw error;
    }
};

// Function to create test subscription
// export const createTestSubscription = async (userId, planId = 1, status = 'trialing', provider = 'stripe') => {
//     try {
//         const payload = {
//             user_id: userId,
//             plan_id: planId,
//             provider,
//             provider_subscription_id: `sub_test_${Date.now()}`,
//             status: status
//         };
        
//         const response = await axios.post(`${apiURL}/subscriptions`, payload);
        
//         if (response.status !== 201 && response.status !== 200) {
//             throw new Error('Failed to create test subscription');
//         }
        
//         return response.data;
//     } catch (error) {
//         console.error('Error creating test subscription:', error);
//         throw error;
//     }
// };

// Function to update subscription status
// export const updateSubscriptionStatus = async (subscriptionId, status) => {
//     try {
//         const response = await axios.put(`${apiURL}/subscriptions/${subscriptionId}`, { status });
        
//         if (response.status !== 200) {
//             throw new Error('Failed to update subscription');
//         }
        
//         return response.data;
//     } catch (error) {
//         console.error('Error updating subscription:', error);
//         throw error;
//     }
// };

// Function to validate subscription status and determine access
export const validateSubscription = (subscription) => {
    if (!subscription) {
        return {
            hasAccess: false,
            status: 'no_subscription',
            redirectTo: '/subscription'
        };
    }

    const now = new Date();
    //const trialEndsAt = subscription.current_period_end ? new Date(subscription.current_period_end) : null;
    const currentPeriodEnd = new Date(subscription.current_period_end);

    switch (subscription.status) {
        case 'trialing':
            if (currentPeriodEnd && currentPeriodEnd > now) {
                return {
                    hasAccess: true,
                    status: 'trial_active',
                    trialEndsAt: currentPeriodEnd,
                    redirectTo: null
                };
            } else {
                return {
                    hasAccess: false,
                    status: 'trial_expired',
                    redirectTo: '/subscription'
                };
            }

        case 'active':
        case 'canceled':
            if (currentPeriodEnd > now) {
                return {
                    hasAccess: true,
                    status: 'active',
                    currentPeriodEnd: currentPeriodEnd,
                    redirectTo: null
                };
            } else {
                return {
                    hasAccess: false,
                    status: 'expired',
                    redirectTo: '/subscription'
                };
            }

        case 'expired':
            return {
                hasAccess: false,
                status: subscription.status,
                redirectTo: '/subscription'
            };

        default:
            return {
                hasAccess: false,
                status: 'unknown',
                redirectTo: '/subscription'
            };
    }
};

// Function to cancel subscription
export const cancelSubscription = async (subscriptionId) => {
    try {
        const token = localStorage.getItem('authToken');
        
        if (!subscriptionId) {
            throw new Error('Subscription ID is required');
        }

        if (!token) {
            throw new Error('Authentication token is required');
        }
        
        const response = await axios.post(`${apiURL}/subscriptions/stripe/cancel`, 
            { subscription_id: subscriptionId },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        if (response.status !== 200) {
            throw new Error('Failed to cancel subscription');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error canceling subscription:', error);
        throw error;
    }
};

// Function to check subscription and return validation result
export const checkSubscriptionAccess = async (userId) => {
    try {
        const subscription = await getUserSubscription(userId);
        return validateSubscription(subscription);
    } catch (error) {
        console.error('Error checking subscription access:', error);
        // On error, deny access and redirect to subscription page
        return {
            hasAccess: false,
            status: 'error',
            error: error.message,
            redirectTo: '/subscription'
        };
    }
};
